const defaultState = {};

export default (state = defaultState, action) => {
    switch (action.type) {
        case 'RELAY_FAXES_SUCCESS':
            return action.outgoingFaxes || defaultState;
        case 'RELAY_FAXES_ERROR':
            return [];
        default:
            return state;
    }
}
